import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ThemeProvider } from "./components/theme-provider";
import "./styles.css";

createRoot(document.getElementById("root")!).render(<StrictMode><ThemeProvider defaultTheme="system"><App /></ThemeProvider></StrictMode>);
